import { Bell } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { ROUTES } from "@/app/routes";

import { useNotifications } from "./use-notifications";

/**
 * ヘッダの通知ベル。未読件数だけを示し、詳細は通知ページに任せる
 * （ドロップダウンは後続で必要になったら足す）。
 */
export function NotificationBell() {
  const { t } = useTranslation("common");
  const { unreadCount } = useNotifications();

  return (
    <Link
      to={ROUTES.notifications}
      aria-label={t("notifications.title")}
      className="hover:bg-accent relative inline-flex size-9 items-center justify-center rounded-md"
    >
      <Bell className="size-4" aria-hidden="true" />
      {unreadCount > 0 ? (
        <span className="bg-destructive text-destructive-foreground absolute -top-0.5 -right-0.5 inline-flex min-w-4 items-center justify-center rounded-full px-1 text-[10px] font-semibold tabular-nums">
          {unreadCount}
        </span>
      ) : null}
    </Link>
  );
}
